import { render, staticRenderFns } from "./SalesOrderValidityReportPage.vue?vue&type=template&id=a37bb14e"
import script from "./SalesOrderValidityReportPage.vue?vue&type=script&lang=js"
export * from "./SalesOrderValidityReportPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports